// resources/js/src/components/community/stories/StoryTrayContainer.tsx

import { useEffect } from "react";
import { useStoryStore } from "../../../../store/storyStore";
import StoryTray from "./components/StoryTray";

const StoryTrayContainer: React.FC = () => {
  const groups = useStoryStore((s) => s.groups);
  const isLoading = useStoryStore((s) => s.isLoading);
  const error = useStoryStore((s) => s.error);
  const loadStories = useStoryStore((s) => s.loadStories);

  useEffect(() => {
    if (groups.length === 0) loadStories();
  }, [groups.length, loadStories]);

  if (isLoading && groups.length === 0) {
    return (
      <div className="flex justify-center py-4">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-3 text-xs text-red-500">
        {error}
        <button
          onClick={loadStories}
          className="ml-2 underline hover:no-underline"
        >
          Retry
        </button>
      </div>
    );
  }

  // ✅ دايماً نعرض الـ tray (زرار الإنشاء يفضل ظاهر حتى لو مفيش مجموعات)
  return <StoryTray groups={groups} />;
};

export default StoryTrayContainer;